import React from "react";
import { Link } from "react-router-dom";
import { setHeaderCollapse } from "../data/redux/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
const CollapseHeader = () => {
  const dispatch = useDispatch();
  const headerCollapse = useSelector(
    (state: any) => state.common.headerCollapse
  );

  const toggleHeaderCollapse = () => {
    dispatch(setHeaderCollapse(!headerCollapse));
  };

  const location = useLocation();
  const navigate = useNavigate();

  const softRefresh = () => {
    setTimeout(() => {
      navigate("/refresh", { replace: true }); // temporary route
      setTimeout(() => {
        navigate(location.pathname, { replace: true }); // return to current route
      }, 0);
    }, 1000); // Delay of 2 seconds
  };

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="refresh-tooltip">Refresh</Tooltip>}
      >
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            softRefresh();
          }}
        >
          <i className="ti ti-refresh-dot" />
        </a>
      </OverlayTrigger>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="collapse-tooltip">Collapse</Tooltip>}
      >
        <Link to="#" id="collapse-header" onClick={toggleHeaderCollapse}>
          <i className="ti ti-chevrons-up" />
        </Link>
      </OverlayTrigger>
    </>
  );
};

export default CollapseHeader;
